import { updateMultipleElements } from '../actions/elementActions';
import { getElementId, getTags } from '../../../common/elements/utils/elementPropertyUtils';
import { ImMNElement } from '../../../common/elements/elementModelTypes';
import { toArray } from '../../../common/utils/immutableHelper';

export const addTagToElements = (elements: Immutable.List<ImMNElement>, tagId: string) => {
    const updates = toArray(
        elements.map((element) => {
            const elementTags = getTags(element) || [];
            if (elementTags.includes(tagId)) return null;

            return {
                id: getElementId(element),
                changes: {
                    tags: [...elementTags, tagId],
                },
            };
        }),
    )?.filter(Boolean);

    return updateMultipleElements({ updates });
};

export const removeTagFromElements = (elements: Immutable.List<ImMNElement>, tagId: string) => {
    const updates = toArray(
        elements.map((element) => {
            const elementTags = getTags(element) || [];
            if (!elementTags.includes(tagId)) return null;

            return {
                id: getElementId(element),
                changes: {
                    tags: elementTags.filter((id: string) => id !== tagId),
                },
            };
        }),
    )?.filter(Boolean);

    return updateMultipleElements({ updates });
};
